import { node, icon } from "~/util/dom";
import { setItem } from "~/util/cookies";
import { CONFIG } from "~/config";

interface ILangItem {
	type: string;
	title: string;
	icon: string;
	hide?: boolean;
	elm?: HTMLAnchorElement | HTMLLIElement;
}

const LANGUAGE = [{
	type: "cs",
	title: "Čeština",
	icon: "cze",
}, {
	type: "en",
	title: "English",
	icon: "gbr",
}, {
	type: "sk",
	title: "Slovenčina",
	icon: "svk",
}, {
	type: "de",
	title: "Deutsch",
	icon: "deu",
}, {
	type: "pl",
	title: "Polski",
	icon: "pol",
}, {
	type: "uk",
	title: "Українська",
	icon: "ukr",
}, {
	type: "ru",
	title: "Pусский",
	icon: "rus",
}, {
	type: "it",
	title: "Italiano",
	icon: "ita",
}, {
	type: "fr",
	title: "Français",
	icon: "fra",
}, {
	type: "es",
	title: "Español",
	icon: "esp",
}];

function buildDomain(lang:string): string {
	return `${CONFIG.BASE_DOMAIN}/${lang}`;
}

function buildItem(lang, myUrl = "") {
	const elm = node("a", {
		className: lang.type,
		href: `https://${buildDomain(lang.type)}${myUrl}`,
	});

	elm.appendChild(node("img", { src: `/img/flags/${lang.icon}.png`, width: 20, height: 20, alt: "" }));
	elm.appendChild(node("span", { textContent: lang.title }));

	return elm;
}

export default class LanguageControl {
	#dom: {
		container: HTMLDivElement;
		list: HTMLUListElement;
		actual?: HTMLAnchorElement;
	};

	#actualLang: string;

	#language: Array<ILangItem>;

	constructor() {
		this.#dom = {
			container: node("div", { className: "language-control2" }),
			list: node("ul"),
		};
		this.#actualLang = CONFIG.defaultLang;
		this.#language = LANGUAGE;

		//jazyky pod klikatkem
		this.#language.push({
			type: "hu",
			title: "Magyar",
			icon: "hun",
			hide: !(Mapy.CUS.lang && Mapy.CUS.lang.hungary),
		}, {
			type: "sl",
			title: "Slovenščina",
			icon: "svn",
			hide: !(Mapy.CUS.lang && Mapy.CUS.lang.slovenija),
		}, {
			type: "da",
			title: "Dansk",
			icon: "dnk",
			hide: !(Mapy.CUS.lang && Mapy.CUS.lang.denmark),
		});

		this.#language.reverse();

		this.#build();
	}

	getContainer() {
		return this.#dom.container;
	}

	get LANGUAGE() {
		return this.#language;
	}

	setUrls(params) {
		const data = structuredClone(params);

		// osetreni po nahozeni webovky , kde prijde prazdnej active
		if ("active" in data) {
			if (data.mapset === "zakladni") {
				delete data.mapset;
			}

			delete data.active;
		}

		// pro roboty odmazeme data, ktera tam nechceme
		if (CONFIG.isScreenshoter) {
			delete data.x;
			delete data.y;
			delete data.z;
			delete data.mapset;

			if (data.mobilepromo) {
				delete data.mobilepromo;

				data.mapset = "mobilepromo";
			}
		}

		// pro boty pres screenshoter generujeme url jinak
		const myUrl = data && (Object.keys(data).length || CONFIG.isScreenshoter) ? Mapy.getComponent("history").getJakHistory2().serializeState(data).replace(`/${CONFIG.defaultLang}`, "") : "";

		this.#language.forEach(lang => {
			const url = `https://${buildDomain(lang.type)}${myUrl}`;

			if (lang.type === this.#actualLang) {
				const elm = lang.elm as HTMLAnchorElement;

				elm.href = url;
			} else if (!lang.hide) {
				lang.elm.querySelector("a").href = url;
			}
		});
	}

	handleEvent(event) {
		event.preventDefault();
		event.stopPropagation();

		if (this.#dom.container.classList.contains("open")) {
			document.getElementById("mapycz").removeEventListener("click", this, false);
			this.#dom.actual.setAttribute("data-log-text", "language-rozbalit");

			for (let index = 0; index < this.#language.length; index++) {
				if (this.#language[index].type !== this.#actualLang) {
					if (!this.#language[index].hide) {
						if (this.#language[index].elm === event.target || this.#language[index].elm.contains(event.target)) {
							setItem("site_lang2", this.#language[index].type, Infinity, "/", `.${CONFIG.BASE_DOMAIN.split(":")[0]}`);

							const url = this.#language[index].elm.querySelector("a").href;

							if (Mapy.Util.linkToNewWindow(event)) {
								window.open(url);
							} else {
								window.location.assign(url);
							}
						}
					}
				}
			}

			this.#dom.container.classList.remove("open");
		} else {
			this.#dom.container.classList.add("open");
			this.#dom.actual.setAttribute("data-log-text", "language-sbalit");
			document.getElementById("mapycz").addEventListener("click", this, false);
		}
	}

	#build() {
		let actual = null;

		this.#language.forEach(lang => {
			if (lang.type === this.#actualLang) {
				actual = buildItem(lang);
				actual.setAttribute("data-log-text", "language-rozbalit");
				actual.setAttribute("data-log-type", lang.title);
				actual.appendChild(icon("dropdown"));
				actual.addEventListener("click", this);

				lang.elm = actual;

				this.#dom.actual = actual;
			} else if (!lang.hide) {
				const item = node("li");
				const link = buildItem(lang);

				link.setAttribute("data-log-text", "language-change");
				link.setAttribute("data-log-type", lang.title);

				item.appendChild(link);
				item.addEventListener("click", this);

				lang.elm = item;

				this.#dom.list.appendChild(item);
			}
		});

		this.#dom.container.appendChild(this.#dom.list);
		this.#dom.container.appendChild(actual);
	}
}
